import * as React from 'react';
import './EligibleRowDesktop.scss';
import localeFormatingInstance from 'src/translation/localeFormating';
import { IEligibleItem } from 'src/services/returns/typings';
import isNumber from 'src/utils/isNumber';
import hasComma from 'src/utils/hasComma';
import IconMessage from 'src/components/common/IconMessage';
import i18n from 'src/translation/i18n';
import Downloadloader from 'src/components/common/Downloadloader';
import { Alert } from '@material-ui/lab';
import { IconButton, Tooltip } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import InvoiceService from 'src/services/invoice';
import { downloadFile } from 'src/utils/downloadHelper';

interface IEligibleRowDesktopProps {
  eligibleItem: IEligibleItem;
  partsToReturn: IEligibleItem[];
  addItemToReturn: (part: IEligibleItem) => void;
  removeItemFromReturn: (id: number) => void;
  loaderStatus: boolean;
  hideShowMsgStatus: boolean;
}

const EligibleRowDesktop: React.FC<IEligibleRowDesktopProps> = props => {
  const {
    eligibleItem,
    partsToReturn,
    addItemToReturn,
    removeItemFromReturn,
    loaderStatus,
    hideShowMsgStatus
  } = props;

  const [quantity, setQuantity] = React.useState<string>('1');
  const [reason, setReason] = React.useState<string>('');
  const [isItemAdded, setIsItemAdded] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [showError, setshowError] = React.useState(false);

  React.useEffect(() => {
    const index = partsToReturn.findIndex(part => part.id === eligibleItem.id);
    if (index !== -1) {
      setQuantity(String(partsToReturn[index].returnQuantity));
      setReason(partsToReturn[index].reason);
      setIsItemAdded(true);
    } else {
      setIsItemAdded(false);
    }
  }, [partsToReturn]);

  const handleChageQuantity = (e: any) => {
    const qty = e.target.value;
    if (isNumber(qty) && qty <= eligibleItem.availableQuantity) {
      setQuantity(qty);
    }
  };

  const handleChangeReason = (e: any) => {
    if (!hasComma(e.target.value)) {
      setReason(e.target.value);
    }
  };

  const handleAddItem = () => {
    if (!isItemAdded) {
      addItemToReturn({
        ...eligibleItem,
        reason,
        returnQuantity: Number(quantity)
      });
    } else {
      removeItemFromReturn(eligibleItem.id);
    }
    setIsItemAdded(!isItemAdded);
  };

  const isValidaNumber = (): boolean => {
    return Number(quantity) > 0;
  };

  const handleCloseMessage = () => {
    // e.preventDefault();
    setshowError(false);
  };

  const getInvoicePreview = (
    e: any,
    invoiceNumber: number,
    invoiceDate: string
  ) => {
    e.preventDefault();
    setshowError(false);
    setShowLoader(true);
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    InvoiceService.downloadInvoice(String(invoiceNumber), String(invoiceDate))
      .then((response: any) => {
        downloadFile(
          response.data,
          `invoice-${invoiceNumber}-${localeFormatingInstance.getNowDate(
            'short'
          )}.pdf`
        );
        setShowLoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowLoader(false);
        setshowError(true);
        // window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  };

  return (
    <React.Fragment>
      {showLoader ? <Downloadloader /> : ''}
      <div className={`rp-eligible-row-desktop ${isItemAdded && 'added'}`}>
        <div className="container-fluid">
          {showError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    handleCloseMessage();
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                <div className="error-message-to-show">
                  {i18n.t('invoices.downloaderror')}
                </div>
              </div>
            </Alert>
          ) : (
            ''
          )}
          <div className="row rp-eligible-row-desktop-wrapper-col">
            <div className="col-4 col-md-2 partNumber">
              <p className="rp-eligible-row-desktop-partNumber">
                {`${
                  eligibleItem.manufacturerCode
                    ? eligibleItem.manufacturerCode
                    : ''
                } ${eligibleItem.partNumber}`}
              </p>
            </div>
            <div className="col-4 col-md-1 invoiceNumber">
              <a
                href="#"
                onClick={e =>
                  getInvoicePreview(
                    e,
                    eligibleItem.invoiceNumber,
                    `${eligibleItem.invoiceDate}`
                  )
                }
                className="rp-eligible-row-desktop-invoice"
              >
                {eligibleItem.invoiceNumber}
              </a>
            </div>
            <div className="col-4 col-md-1 invoiceDate">
              <p>
                {localeFormatingInstance.formatDate(
                  eligibleItem.invoiceDate,
                  'short'
                )}
              </p>
            </div>
            <div className="col-1 price">
              <p className="rp-eligible-row-desktop-bold price">
                {localeFormatingInstance.formatCurrency(eligibleItem.price)}
                {eligibleItem.hasCoreIncluded && (
                  <IconMessage
                    icon={'rpds-error'}
                    isIconInline={true}
                    message={'This price includes a Core Charge'}
                  />
                )}
              </p>
            </div>
            <div className="col-1 returnQty">
              <input
                type="text"
                className="rp-eligible-row-desktop-qty rp-eligible-row-desktop-input"
                value={quantity}
                onChange={handleChageQuantity}
                disabled={isItemAdded}
              />
              <span>/ {eligibleItem.availableQuantity}</span>
            </div>
            <div className="col-1 d-flex justify-content-center restockingFee">
              <p>{eligibleItem.returnFee ? eligibleItem.returnFee : 0}%</p>
            </div>
            <div className="col-3 reason">
              <input
                type="text"
                className="rp-eligible-row-desktop-reason rp-eligible-row-desktop-input"
                value={reason}
                onChange={handleChangeReason}
                disabled={isItemAdded}
                maxLength={60}
              />
            </div>
            <div className="col-2 d-flex justify-content-center align-items-center options">
              <div
                className={`rp-eligible-row-desktop-button ${!isValidaNumber() &&
                  'disabled'}`}
                onClick={isValidaNumber() ? handleAddItem : null}
              >
                {isItemAdded ? (
                  <>
                    <i className="rpds-remove rp-eligible-row-desktop-remove-icon" />
                    <p className="rp-eligible-row-desktop-add">
                      {' '}
                      {i18n.t('common.removeAction')}{' '}
                    </p>
                  </>
                ) : (
                  <>
                    <i
                      className={`rpds-add rp-eligible-row-desktop-add-icon ${!isValidaNumber() &&
                        'disabled'}`}
                    />
                    <p
                      className={`rp-eligible-row-desktop-add ${!isValidaNumber() &&
                        'disabled'}`}
                    >
                      {i18n.t('myReturns.addToReturnsCart', {
                        interpolation: { escapeValue: false }
                      })}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EligibleRowDesktop;
